import { useEffect, useState } from "react";
import { getCurrentUserEmployee } from "../data/employeeData";
import { loadUserPreferences } from "./userPreferences";

/**
 * The signed-in user's display name, for the top right of the portal.
 *
 * Also pulls their saved preferences down on the way through, since both come
 * from the employee record and both are wanted as soon as the user is in.
 * Falls back to "User" if the lookup fails, so the topbar never renders empty.
 */
export function useCurrentUserName(): string {
  const [userName, setUserName] = useState<string>("");

  useEffect(() => {
    let cancelled = false;

    const load = async () => {
      loadUserPreferences();

      try {
        const employee = await getCurrentUserEmployee();
        if (!cancelled && employee?.employeeName) {
          setUserName(employee.employeeName);
        }
      } catch (error) {
        console.warn("Could not load the current user:", error);
      }
    };

    load();

    return () => {
      cancelled = true;
    };
  }, []);

  return userName || "User";
}
